export enum PricingMethod {
  Quantity = 0,
  HeadCount = 1,
  AddOns = 2,
}
